import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import { EditNote, Visibility } from '@mui/icons-material';

// Ui
import AppPage from '@/ui/AppPage/AppPage';
import MapCentricPage from '@/ui/MapCentric/MapCentricPage';
import TableButton from '@/ui/Table/ActionButtons/TableButton';

// Context
import DialogContext from '@/context/DialogContext/DialogContext';

// Lib
import Permissions from '@/lib/permissions';

// Models
import UpitnikOdgovori, { UpitnikOdgovorStatus } from '@/models/groblja/upitnik_odgovori';

// Types
import { DCRecord } from '@/@types/lib/dataController';

import UpitnikOdgovorDialog from './UpitnikOdgovorDialog';
import UpitnikOdgovoriStatusDialog from './UpitnikOdgovoriStatusDialog';

type Selection = { [key: string]: DCRecord };

const UpitnikOdgovoriMapCentricPage = () => {
  const { t } = useTranslation();
  const { showDialog } = useContext(DialogContext);

  const handlePrikazi = (sel: Selection) => {
    const record = Object.values(sel)[0];
    if (record) showDialog(UpitnikOdgovorDialog, { record });
  };

  const handlePromijeniStatus = (sel: Selection, refresh: () => void) => {
    const records = Object.values(sel);
    const statusi = new Set(records.map((rec) => rec.status as UpitnikOdgovorStatus));
    showDialog(UpitnikOdgovoriStatusDialog, {
      ids: records.map((rec) => rec.id as number),
      currentStatus: statusi.size === 1 ? [...statusi][0] : null,
      onSaved: refresh,
    });
  };

  const renderSelectionActions = (refresh: () => void) => [
    <TableButton
      key="prikazi"
      variant="outlined"
      allow="one"
      selection={{}}
      startIcon={<Visibility />}
      tooltip={t('groblja:upitnik_odgovori.prikazi_hint') as string}
      onClick={(evt, sel: Selection) => handlePrikazi(sel)}
    >
      {t('groblja:upitnik_odgovori.prikazi')}
    </TableButton>,
    <TableButton
      key="status"
      variant="contained"
      allow="many"
      selection={{}}
      startIcon={<EditNote />}
      tooltip={t('groblja:upitnik_odgovori.promijeni_status_hint') as string}
      onClick={(evt, sel: Selection) => handlePromijeniStatus(sel, refresh)}
    >
      {t('groblja:upitnik_odgovori.promijeni_status')}
    </TableButton>,
  ];

  return (
    <AppPage titlett="groblja:titles.upitnik_odgovori" needPermission={[Permissions.GrobljaUpitnikOdgovori]}>
      <MapCentricPage
        model={UpitnikOdgovori}
        titleToken="groblja:titles.upitnik_odgovori"
        view="default"
        baseRecordPath=""
        mapId={48}
        mapModel={UpitnikOdgovori}
        mapRecordField="grobno_mjesto_id"
        allowExport
        multiSelect
        renderSelectionActions={renderSelectionActions}
      />
    </AppPage>
  );
};

export default UpitnikOdgovoriMapCentricPage;
